module.exports = __webpack_public_path__ + "static/media/noti.c8e4cd2.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/noti.mp3
// module id = MEIo
// module chunks = 1